import React, { Suspense, lazy } from 'react'
import PropTypes from "prop-types"
import './App.scss'
import 'antd-mobile/dist/antd-mobile.css';
import { Switch, Route } from "react-router-dom"
import Loading from './components/common/Loading'

// import EnterpriseWallet from './containers/EnterpriseWallet'
// import Home from './containers/EnterpriseWallet/router/Home'
const FirmAsset = lazy(() => import('./containers/EnterpriseWallet/router/FirmAsset'))
const HistoryList = lazy(() => import('./containers/EnterpriseWallet/router/HistoryList'))
const POSlist = lazy(() => import('./containers/EnterpriseWallet/router/POSlist'))
const POSdetail = lazy(() => import('./containers/EnterpriseWallet/router/POSdetail'))
const Detail = lazy(() => import('./containers/EnterpriseWallet/router/Detail'))
const Settings = lazy(() => import('./containers/EnterpriseWallet/router/Settings'))
const Psw1 = lazy(() => import('./containers/EnterpriseWallet/router/Psw1'))
const Psw2 = lazy(() => import('./containers/EnterpriseWallet/router/Psw2'))
const AlterPage = lazy(() => import('./containers/EnterpriseWallet/router/AlterPage'))
const changePsw = lazy(() => import('./containers/EnterpriseWallet/router/changePsw'))
const Info = lazy(() => import('./containers/EnterpriseWallet/router/Info'))
const SetPS = lazy(() => import('./containers/EnterpriseWallet/router/SetPS'))
const ServiceRules = lazy(() => import('./containers/EnterpriseWallet/router/ServiceRules'))
const Certified = lazy(() => import('./containers/EnterpriseWallet/router/Certified'))
const UnCertified = lazy(() => import('./containers/EnterpriseWallet/router/UnCertified'))
const OverCertified = lazy(() => import('./containers/EnterpriseWallet/router/OverCertified'))
const Status = lazy(() => import('./containers/EnterpriseWallet/router/Status'))
const Tixian = lazy(() => import('./containers/EnterpriseWallet/router/Tixian'))
const BankCards = lazy(() => import('./containers/EnterpriseWallet/router/BankCards'))
const DeleteBank = lazy(() => import('./containers/EnterpriseWallet/router/DeleteBank'))
const Functions = lazy(() => import('./containers/EnterpriseWallet/router/Functions'))
const AddBank = lazy(() => import('./containers/EnterpriseWallet/router/AddBank/AddBank'))
const AddGoldBank = lazy(() => import('./containers/EnterpriseWallet/router/AddGoldBank/AddGoldBank'))
const ChooseBankType = lazy(() => import('./containers/EnterpriseWallet/router/ChooseBankType/ChooseBankType'))
const SuccessPage = lazy(() => import('./containers/EnterpriseWallet/router/SuccessPage/SuccessPage'))
const Home = React.lazy(() => import('./containers/EnterpriseWallet/router/Home'))

//金条项目
//金条项目金融产品列表页
const ProductList = lazy( () => import('./containers/Jintiao/ProductList'));
//金条项目开户页面 企业
const JOpenAccount = lazy( () => import('./containers/Jintiao/OpenAccount'));
//金条项目开户页面 个人
const OpenPersonalAccount = lazy( () => import('./containers/Jintiao/OpenPersonalAccount'));
// 金条项目壹钱包开户协议
const Yiqianbao = lazy( () => import('./containers/Jintiao/Xieyi/Yiqianbao'));
// 金条项目壹钱包开户协议
const Bohai = lazy( () => import('./containers/Jintiao//Xieyi/Bohai'));
// 金条项目平台服务协议（金条平台）
const Pingtai = lazy( () => import('./containers/Jintiao/Xieyi/Pingtai'));
// 金条项目壹钱包开户协议
const Gongxiang = lazy( () => import('./containers/Jintiao/Xieyi/Gongxiang'));
const Gongxiangs = lazy( () => import('./containers/Jintiao/Xieyi/Gongxiangs'));
// 金条项目平台服务协议（金条平台）
const Weituo = lazy( () => import('./containers/Jintiao/Xieyi/Weituo'));


const App = (location) => (
    //支付企业钱包项目 path=/biz/wallet/*
    <div className="pay_wallet">
        <Suspense fallback={<Loading />}>
            <Switch>
                {/*企业M站*/}
                <Route exact path='/biz/wallet' component={Home} />
                {/* 企业资产 */}
                <Route exact path='/biz/wallet/firmasset' component={FirmAsset} />
                {/* 对账单 */}
                <Route exact path='/biz/wallet/historylist' component={HistoryList} />
                <Route exact path='/biz/wallet/detail' component={Detail} />
                {/* 实时交易 */}
                <Route exact path='/biz/wallet/poslist' component={POSlist} />
                {/* POS详情页 */}
                <Route exact path='/biz/wallet/POSdetail' component={POSdetail} />
                {/* 设置 */}
                <Route exact path='/biz/wallet/settings' component={Settings} />
                {/* 修改支付密码 */}
                <Route exact path='/biz/wallet/changepsw' component={changePsw} />
                {/* 找回支付密码  分为手机和邮箱两种方式 */}
                <Route exact path='/biz/wallet/psw/type' component={Psw1} />
                <Route exact path='/biz/wallet/psw/infos' component={Psw2} />
                {/* 手机、邮箱验证 */}
                <Route exact path='/biz/wallet/alterpage' component={AlterPage} />
                {/* 完善企业信息 */}
                <Route exact path='/biz/wallet/info' component={Info} />
                {/* 设置支付密码 */}
                <Route exact path='/biz/wallet/setps' component={SetPS} />
                {/* 车支付钱包服务协议 */}
                <Route exact path='/biz/wallet/rules' component={ServiceRules} />
                {/* 企业信息 */}
                <Route exact path='/biz/wallet/certified' component={Certified} />
                {/* 实名认证(未实名) */}
                <Route exact path='/biz/wallet/uncertified' component={UnCertified} />
                {/* 实名认证(已实名) */}
                <Route exact path='/biz/wallet/overcertified' component={OverCertified} />
                {/* 申请状态 */}
                <Route exact path='/biz/wallet/status' component={Status} />
                {/* 提现 */}
                <Route exact path='/biz/wallet/tixian' component={Tixian} />
                {/* 银行卡选择 */}
                <Route exact path='/biz/wallet/bankcards' component={BankCards} />
                {/* 删除银行卡 */}
                <Route exact path='/biz/wallet/deletebank' component={DeleteBank} />
                {/* 充值提现转账 */}
                <Route exact path='/biz/wallet/functions' component={Functions} />
                {/* 添加车支付银行卡 */}
                <Route exact path='/biz/wallet/addbank' component={AddBank} />
                {/* 添加金条银行卡  字段差异较大，且分了对公和对私，所以和车支付分开 */}
                <Route exact path='/biz/wallet/addgoldbank' component={AddGoldBank} />
                {/* 选择添加银行卡的类型 */}
                <Route exact path='/biz/wallet/choosebanktype' component={ChooseBankType} />
                {/* 成功通用页面 */}
                <Route exact path='/biz/wallet/success' component={SuccessPage} />

                {/* 金条项目  */}
                <Route location={location} path="/biz/productList" component={ProductList} />
                <Route location={location} path="/biz/openAccount" component={JOpenAccount} />
                <Route location={location} path="/biz/openPersonalAccount" component={OpenPersonalAccount} />
                <Route location={location} path="/biz/yiqianbao" component={Yiqianbao} />
                <Route location={location} path="/biz/bohai" component={Bohai} />
                <Route location={location} path="/biz/gongxiang" component={Gongxiang} />
                <Route location={location} path="/biz/gongxiangs" component={Gongxiangs} />

                <Route location={location} path="/biz/weituo" component={Weituo} />

                <Route location={location} path="/*" component={Home} />
            </Switch>
        </Suspense>
    </div>
)

App.propTypes = {
    location: PropTypes.shape({
        pathname: PropTypes.string.isRequired
    }).isRequired
};
export default App;
